// extracted by mini-css-extract-plugin
export var labelWrapper = "_g4-0";